// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const tapu_bulu: PokeData = {
  "id": 787,
  "name": "tapu-bulu",
  "height": 19,
  "weight": 455,
  "base_experience": 257,
  "types": [
    PokeType.GRASS,
    PokeType.FAIRY
  ],
  "api_moves": [
    "whirlwind",
    "horn-attack",
    "disable",
    "mega-drain",
    "leech-seed",
    "withdraw",
    "skull-bash",
    "scary-face",
    "giga-drain",
    "mean-look",
    "megahorn",
    "rock-smash",
    "superpower",
    "zen-headbutt",
    "wood-hammer",
    "horn-leech",
    "rototiller",
    "grassy-terrain",
    "leafage",
    "natures-madness"
  ],
  "moves": [
    "scary-face",
    "rock-smash",
    "superpower",
    "zen-headbutt",
    "wood-hammer",
    "rototiller",
    "grassy-terrain",
    "mist-terrain",
    "flower-rush",
    "aromatherapy",
    "frenzy-plant",
    "energy-ball",
    "synthesis"
  ],
  "evolution_chain": {
    "id": 411,
    "item": null,
    "species": [
      {
        "name": "tapu-bulu",
        "order": 787,
        "types": [
          PokeType.GRASS,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 120,
    "speed": 103,
    "ability_power": 178
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
